import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import Seal from "@/components/Seal";
import { Target, Layers, ShieldCheck, Globe } from "lucide-react";

const PageHeader = ({ eyebrow, title, subtitle }) => (
  <section className="hero-wash border-b border-[var(--wechr-border)]">
    <div className="wechr-container py-12 sm:py-16">
      {eyebrow && <p className="text-sm font-semibold uppercase tracking-wide text-wgreen-700">{eyebrow}</p>}
      <h1 className="mt-2 font-heading text-3xl font-semibold tracking-tight text-navy-900 sm:text-4xl">{title}</h1>
      {subtitle && <p className="mt-3 max-w-2xl text-base leading-relaxed text-navy-800">{subtitle}</p>}
    </div>
  </section>
);

const About = () => (
  <div>
    <PageHeader eyebrow="About WECH-RB" title="We Create Harmony with Responsible Businesses"
      subtitle="WECH-RB is an independent document-review-based certification platform for EHS, ESG, business ethics, anti-corruption, responsible procurement, supplier due diligence, and AI governance, security & responsible use." />
    <section className="wechr-section">
      <div className="wechr-container grid gap-10 lg:grid-cols-3">
        <div className="lg:col-span-2 space-y-5 text-navy-800">
          <p className="leading-relaxed">WECH-RB combines proven frameworks into a single, accessible certification: RBA-style supplier Code of Conduct topics, EcoVadis-style ESG and sustainable procurement scorecard topics, FCPA-style anti-bribery and anti-corruption controls, third-party due diligence and supplier risk screening concepts, and modern AI governance, security, and responsible-use principles.</p>
          <p className="leading-relaxed">Our first-version certification is <strong>document-review based</strong> — no on-site audit is required. Applicants apply online, complete a structured questionnaire, upload supporting evidence, and receive an AI-assisted preliminary review followed by an admin document review that determines final certification.</p>
          <p className="leading-relaxed">We believe responsible companies help create a safer, more ethical, more sustainable, and more harmonious society — and that credible, evidence-based certification helps buyers and partners recognize them.</p>
        </div>
        <Card className="h-fit">
          <CardContent className="p-6">
            <Seal size={40} />
            <h3 className="mt-4 font-heading text-base font-semibold text-navy-900">WECH-RB DD Certification</h3>
            <p className="mt-1 text-sm text-[var(--wechr-muted-text)]">Document-Reviewed EHS, ESG, Ethics, Supplier Due Diligence & AI Governance Certification.</p>
          </CardContent>
        </Card>
      </div>
      <div className="wechr-container mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {[
          { icon: Target, t: "Independent", d: "An impartial, evidence-driven review process." },
          { icon: Layers, t: "Comprehensive", d: "Six categories spanning labor, EHS, ethics, procurement, management, and AI governance." },
          { icon: ShieldCheck, t: "Verifiable", d: "Every certificate is publicly verifiable with a unique ID." },
          { icon: Globe, t: "Global", d: "Designed for suppliers and manufacturers worldwide." },
        ].map((f) => (
          <Card key={f.t}><CardContent className="p-6"><f.icon className="h-6 w-6 text-wgreen-600" /><h4 className="mt-3 font-heading text-sm font-semibold text-navy-900">{f.t}</h4><p className="mt-1 text-sm text-[var(--wechr-muted-text)]">{f.d}</p></CardContent></Card>
        ))}
      </div>
    </section>
  </div>
);

export { PageHeader };
export default About;
